export default __webpack_public_path__ + "static/announcement-345fd0933348c0ec24b4b89689187452.svg";